import type { ConnectionKind } from '@common-reducers/ConnectedEnginesSlice';

/** A message only WhatsApp Web can send (no always-on connection) and due more than an hour away
 *  goes out only if WhatsApp Web is open on a computer at that moment — say so before scheduling.
 *  Within the hour the tab the user is looking at is very likely still open: no warning — except a
 *  recurring series, whose later occurrences all need WhatsApp Web open. */
export function shouldWarnLocalSend(i: { kind: ConnectionKind; dueDate: string | Date | undefined; now: number; isRecurring?: boolean }): boolean {
  if (i.kind === 'remote') return false;
  if (i.isRecurring) return true;
  if (!i.dueDate) return false;
  const due = new Date(i.dueDate).getTime();
  if (Number.isNaN(due)) return false;
  return due - i.now > 60 * 60_000;
}
